import Script from 'next/script'
import { APPZI_TOKEN } from '@/constants'

export default async function AppziLoader() {
  return APPZI_TOKEN ? (
    <>
      {/* <!-- Appzi: Capture Insightful Feedback --> */}
      <Script async src={`https://w.appzi.io/w.js?token=${APPZI_TOKEN}`}></Script>
      {/* <!-- End Appzi --> */}
    </>
  ) : null
}

export const appziIdentity = (accountId: string, defaultAudience?: string) => {
  if (accountId) {
    ;(window as any).appziSettings = {
      userId: accountId,
      data: {
        account_id: {
          value: accountId,
          label: 'Account Id',
        },
        audience: defaultAudience
          ? {
              value: defaultAudience,
              label: 'Audience',
            }
          : undefined,
      },
      render: {
        type: 'client',
      },
    }
  }
}
